import { useMutation } from 'react-query';
import Api from 'src/api/Api';

export const useGoogleTranslate = () => {
  return useMutation(Api.googleTranslate, {});
};
